module.exports = __webpack_public_path__ + "img/Feature.1619c1e8.jpg";